module.exports = __webpack_public_path__ + "static/media/IMG_8853.ecd8d2e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_8853.jpg
// module id = 165
// module chunks = 0